import { alkymetricsClient } from '../alkymetricsClient';

export const getUnreviewedEvaluations = async (workspaceId, page = 1, limit = 10) => {
  try {
    const { data } = await alkymetricsClient.get('/partner-to-candidate/unreviewed-evaluations', {
      params: { workspaceId, page, limit },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const markEvaluationsAsRead = async (ids) => {
  try {
    const { data } = await alkymetricsClient.post('/partner-to-candidate/mark-as-read', { ids });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getUnreviewedCount = async (workspaceId) => {
  try {
    const { data } = await alkymetricsClient.get('/partner-to-candidate/unreviewed-count', {
      params: { workspaceId },
    });
    return data.count;
  } catch (error) {
    throw error;
  }
};

export const markAsReadByInvitation = async (assessmentInvitationId) => {
  try {
    const { data } = await alkymetricsClient.post(
      '/partner-to-candidate/mark-as-read-by-invitation',
      {
        assessmentInvitationId,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};
